export const SCREENING_USER_EMAIL_VERIFICATION_REQUEST = '/candidate-email-verification-request';
export const SCREENING_USER_REGISTRATION = '/candidate-registration';
export const CANDIDATE_CV_EXTRACTION = '/candidate-registration/ai-extract';
export const CANDIDATE_DOCUMENT_EXTRACTION = '/candidate-registration/ai-extract-documents';
export const APPLICANT_INFO_UPDATE = '/candidate-info-update';
export const APPLICANT_FILES = '/applicant-files';
export const APPLICANT_FILES_TO_INPUT_CHECKLIST = '/applicant-files/checklist-files';
export const CANDIDATES = '/candidates';
export const SHORT_LIST_CANDIDATE_POST = 'shortList-Candidate';
export const SHORT_LIST_CANDIDATES = 'shotListed-candidates';
export const CREATE_NEW_APPLICATION = '/create_new_application';
export const ADD_APPLICANT_COMMENT = '/screen-status';
export const GET_APPLICANT_DATA_BY_ID = '/applicant-data?id=';
export const GET_APPLICANT_DATA_BY_EMAIL = '/applicant-data?email=';
export const APPLICANT_SEARCH = '/applicant-search?applicant_id=';
export const SCREENING_SCHEDULE = '/screening-schedule';
export const COMPLETED_SCREENING = '/completed-screening';
export const CHANGE_SCREENING_STATUS = '/screeningSchedule/change-screening-status';
export const VETTING = '/complete-screening';
export const SCREENING_CHECKLIST = '/screening-checklist';
export const CREDITS = '/credits';
export const AVAILABLE_CREDITS = '/available-credits';
export const CREDIT_TRANSACTIONS = '/credit-transactions';
export const PUBLIC_APPLICATION_LINK = '/public-application-form-link';
export const ADD_TO_EMPLOYMENT = '/applicant/employment';
export const APPLICANT_ENDORSEMENT = '/applicant/endorsement';
export const GET_SCREENING_FORMS = '/document/get-screening-forms';
export const GET_ASSIGNED_SCREENING_FORMS = '/document/get-assigned-screening-forms';
export const ASSIGN_FORMS_TO_EMPLOYEE = '/employee/assign-forms';

export const SCREENING_ENDORSEMENT_DETAIL = '/screening-endorsement/detail/';
export const SCREENING_ENDORSEMENT_UPDATE = '/screening-endorsement/update';

export const APPLICANT_SOCIAL_MEDIA_CHECK = '/applicant-social-media-check';
export const DELETE_APPLICATION = '/delete-application';
export const UPDATE_CHECKLIST_ORDER = '/update-checkList-order';
export const GET_FORM_RESPONSE = '/screening/form-response';

export const SCREENING_REPORT_TEMPLATE_SETTINGS = '/screening-report-template-settings';
export const SCREENING_REPORT_TEMPLATE_SETTINGS_GET = '/screening-report-template-settings/get';
export const SCREENING_REPORT_TEMPLATE_PREVIEW = '/screening-report-template-preview';
